import { Sidebar } from "./Sidebar";
import { Link } from "react-router-dom";
import { PageGuide } from "./Explain";
import { GmariBadge } from "./GmariBadge";
import { GlobalAskMAI } from "./GlobalAskMAI";

export const PageShell = ({ overline, title, actions, pageId, children, embedded, movedTo }) => {
  if (embedded) {
    return (
      <div className="space-y-6">
        {actions && <div className="flex flex-wrap items-center justify-end gap-2">{actions}</div>}
        {children}
      </div>
    );
  }
  return (
  <div className="flex min-h-screen bg-[#F8FAFC]">
    <Sidebar />
    <GlobalAskMAI />
    <div className="flex-1 min-w-0">
      <header className="sticky top-0 z-20 bg-white/70 backdrop-blur-xl border-b border-slate-200/70">
        <div className="px-6 lg:px-10 py-4 flex items-center gap-4">
          <div className="flex-1 min-w-0">
            <p className="overline-label text-slate-400">{overline}</p>
            <h1 className="font-heading font-extrabold text-xl tracking-tight mt-0.5">{title}</h1>
          </div>
          <GmariBadge />
          {actions}
        </div>
      </header>
      <main className="px-6 lg:px-10 py-8 space-y-8">
        {movedTo && (
          <div data-testid="moved-banner" className="border border-amber-200 bg-amber-50 px-4 py-2.5 text-xs text-amber-800 flex items-center justify-between">
            <span>This module now lives inside the simplified Evidence experience.</span>
            <Link to={movedTo.to} className="font-bold underline hover:text-amber-950">{movedTo.label} →</Link>
          </div>
        )}
        {pageId && <PageGuide pageId={pageId} />}
        {children}
      </main>
    </div>
  </div>
  );
};
